<template>
    <div class="card card-white flex items-center justify-between space-x-4">
        <a :href="block.user.url" class="block text-black dark:text-white flex items-center space-x-4">
            <div class="block w-8 h-8 md:w-12 md:h-12 shrink-0">
                <avatar :ava="block.user.ava" :online="block.user.is_online" class="w-8 h-8 md:w-12 md:h-12"></avatar>
            </div>

            <span class="font-medium truncate">{{ block.user.name }}</span>

            <svg-icon
                    icon="check-circle-fill"
                    v-if="block.user.is_verified"
                    class="w-3 h-3 text-blue-500 shrink-0">
            </svg-icon>
        </a>
        <div>
            <block-user :block="block" :userid="block.blocked_user_id"></block-user>
        </div>
    </div>
</template>
<script>
import User from "../../js/modules/User";
import BlockUser from "./BlockUser.vue";
import Avatar from "./Avatar.vue";

let store;
export default {
	components: {Avatar, BlockUser},
	props: [
		'block',
	],
	data() {
		return {
			currentUser: new User(),
		};
	},
}
</script>